export class ResponseTapError extends Error {}
export class MissingRouterError extends ResponseTapError {
  constructor () {
    super('a router is required')
  }
}
export class MissingSelectorError extends ResponseTapError {
  constructor () {
    super('a selector is required')
  }
}
export class MissingSetterError extends ResponseTapError {
  constructor () {
    super('a setter is required')
  }
}

export default class ResponseTap {
  constructor (options) {
    const { router, selector, setter, storageKey, storage, container } = options

    if (!router) throw new MissingRouterError()
    if (!selector) throw new MissingSelectorError()
    if (!setter) throw new MissingSetterError()

    this.router = router
    this.selector = selector
    this.setter = setter
    this.storage = storage || window.localStorage
    this.storageKey = storageKey || 'rt_r'
    this.container = container || document.createElement('div')

    this.boundRouterGuard = this.assertQueryParam.bind(this)
  }

  init () {
    this.initRouterGuard()
    this.initContainer()
  }

  initRouterGuard () {
    this.router.beforeEach(this.boundRouterGuard)
  }

  initContainer () {
    this.injectContainer()
    this.observeContainer()
  }

  injectContainer () {
    this.container.classList.add(this.selector)
    this.container.style.display = 'none'
    document.body.appendChild(this.container)
  }

  observeContainer () {
    return new MutationObserver(() => this.setter(this.container.textContent.replace(/\s/, '')))
      .observe(this.container, { childList: true })
  }

  assertQueryParam (to, from, next) {
    let value = this.storage.getItem(this.storageKey) || to.query.r

    if (!this.storage.getItem(this.storageKey) && value) this.storage.setItem(this.storageKey, value)

    if (to.query.r && to.query.r !== value) {
      this.storage.setItem(this.storageKey, to.query.r)
      value = to.query.r
    }

    if (!to.query.r && value) {
      next({ ...to, query: { ...to.query, r: value } })
    }

    next()
  }

  static install (Vue, options) {
    const responseTap = new ResponseTap(options)
    responseTap.init()
    return responseTap
  }
}
